/* eslint-disable react-hooks/exhaustive-deps */
import { Form, notification, Radio, Select, Space, Switch, Upload } from 'antd';
import { useTranslation } from 'react-i18next';
import ImgCrop from 'antd-img-crop';

import Collapse from '../Collapse';
import { ICON } from './icon';
import { useMemo, useState } from 'react';
import { useEffect } from 'react';
import GlobalService from '../../../../services/Global.service';
import InputColor from '../../../../components/Shared/forms/InputColor';
import { useDsRequestContext } from '../../context';

const { Option } = Select;

const CustomizeStyle = ({ form, initialValue }) => {
    const { t } = useTranslation();
    const [fileList, setFileList] = useState([]);
    const [errorColor, setErrorColor] = useState(false);
    const [errorColorStyle, setErrorColorStyle] = useState(false);
    const [errorLogo, setErrorLogo] = useState(false);

    const UIContext = useDsRequestContext();
    const UIProps = useMemo(() => {
        return {
            setLogo: UIContext.setLogo,
        };
    }, [UIContext]);

    const companyLogoId = form.getFieldValue(['logo', 'companyLogoId']);
    const showLogo = form.getFieldValue(['logo', 'hiddenLogo']);

    useEffect(() => {
        if (companyLogoId) {
            getImage(companyLogoId);
        } else {
            UIProps.setLogo();
            setFileList([]);
        }
    }, [companyLogoId]);

    useEffect(() => {
        setErrorColor(false);
        setErrorLogo(false);
        setErrorColorStyle(false);
    }, [initialValue]);

    const getImage = async (logoId) => {
        try {
            const { data } = await GlobalService.getImageNoSecure(logoId);
            if (data.resultData?.imageId) {
                UIProps.setLogo(
                    `data:image/png;base64,${data.resultData?.imageId}`
                );
                setFileList([
                    {
                        uid: '-1',
                        name: 'image.png',
                        status: 'done',
                        url: `data:image/png;base64,${data.resultData?.imageId}`,
                    },
                ]);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const beforeUpload = (file) => {
        const isJpgOrPng =
            file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            notification['error']({
                message: 'You can only upload JPG/PNG file!',
            });
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            notification['error']({
                message: t('COOKIE.ImageMustSmaller'),
            });
        }
        return isJpgOrPng && isLt2M;
    };

    const onPreview = async (file) => {
        let src = file.url;
        if (!src) {
            src = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
            });
        }
        const image = new Image();
        image.src = src;
        const imgWindow = window.open(src);
        imgWindow?.document.write(image.outerHTML);
    };

    const uploadProps = {
        multiple: false,
        listType: 'picture-card',
        beforeUpload,
        className: 'customize_logo mt-2',
        accept: '.png,.jpg,.jpeg',
        fileList,
        onPreview,
        onChange(info) {
            const { status } = info.file;
            if (status === 'uploading') {
                info.file.status = 'done';
            }
            if (status === 'done' || status === 'removed') {
                setFileList(info.fileList);
            }
        },
        onSuccess: async (res) => {
            form?.setFieldValue(['logo', 'companyLogoId'], res?.imageId);
            form.setFields([
                {
                    name: ['logo', 'companyLogoId'],
                    errors: [],
                },
            ]);
            try {
                const { data } = await GlobalService.getImageNoSecure(
                    res?.imageId
                );
                if (data.resultData?.imageId) {
                    UIProps.setLogo(
                        `data:image/png;base64,${data.resultData?.imageId}`
                    );
                }
            } catch (error) {
                console.log(error);
            }
        },
        onError(err) {
            console.log('onError', err);
        },
        onRemove() {
            form?.setFieldsValue({
                logo: {
                    companyLogoId: null,
                },
            });
            UIProps.setLogo();
            if (showLogo) {
                setErrorLogo(true);
            }
        },
        customRequest: async ({ file, onSuccess, onError }) => {
            let fileList = new FormData();
            fileList.append('image', file);
            fileList.append('fileName', file.name);
            fileList.append('action', 'image-create-application');
            try {
                const { data } = await GlobalService.uploadImage(fileList);
                if (data?.resultData?.imageId) {
                    onSuccess(data?.resultData, file);
                    form.validateFields([['logo', 'companyLogoId']]);
                } else {
                    onError('error');
                }
            } catch (error) {
                onError(error);
            }
        },
    };

    const checkColor = (_, value) => {
        if (value) {
            setErrorColor(false);
            return Promise.resolve();
        }
        setErrorColor(true);
        return Promise.reject(new Error(t('errorText.requiredField')));
    };

    const checkColorStyle = (_, value) => {
        if (value) {
            setErrorColorStyle(false);
            return Promise.resolve();
        }
        setErrorColorStyle(true);
        return Promise.reject(new Error(t('errorText.requiredField')));
    };

    const checkLogo = (_, value) => {
        if (showLogo) {
            if (value) {
                setErrorLogo(false);
                return Promise.resolve();
            } else {
                setErrorLogo(true);
                return Promise.reject(new Error(t('errorText.requiredField')));
            }
        }
        if (!showLogo) {
            setErrorLogo(false);
            return Promise.resolve();
        }
        setErrorLogo(true);
        return Promise.reject(new Error(t('errorText.requiredField')));
    };

    useEffect(() => {
        form.validateFields([['logo', 'companyLogoId']]);
    }, [showLogo, form]);

    return (
        <div>
            <div className="text-[#999999] font-semibold text-xs uppercase">
                {t('Customize your style')}
            </div>
            <div
                style={{ borderBottom: '1px solid #F2F2F2' }}
                className="w-full my-2"
            ></div>
            <div className="space-y-2">
                <Collapse
                    error={errorColor}
                    icon={ICON.SIX}
                    title={t('SetColor')}
                >
                    <Form.Item
                        label={
                            <div className="font-semibold mb-2 text-sm">
                                {t('Background color')}
                            </div>
                        }
                        name={['customizeStyle', 'mainColor']}
                        rules={[
                            {
                                validator: checkColor,
                            },
                        ]}
                    >
                        <InputColor />
                    </Form.Item>
                    <Form.Item
                        label={
                            <div className="font-semibold mb-2 text-sm">
                                {t('CardColor')}
                            </div>
                        }
                        name={['customizeStyle', 'bgColor']}
                        rules={[
                            {
                                validator: checkColor,
                            },
                        ]}
                    >
                        <InputColor />
                    </Form.Item>
                    <Form.Item
                        label={
                            <div className="font-semibold mb-2 text-sm">
                                {t('ButtonColor')}
                            </div>
                        }
                        name={['customizeStyle', 'buttonColor']}
                        rules={[
                            {
                                validator: checkColor,
                            },
                        ]}
                    >
                        <InputColor />
                    </Form.Item>
                </Collapse>
                <Collapse
                    error={errorColorStyle}
                    icon={ICON.SEVEN}
                    title={t('Set the font style')}
                >
                    <Form.Item
                        label={
                            <div className="font-semibold mb-2 text-sm">
                                {t('Font Family')}
                            </div>
                        }
                        name={['fontStyle', 'fontFamily']}
                    >
                        <Select size="large" style={{ width: '100%' }}>
                            <Option value="arial">Arial (EN)</Option>
                            <Option value="georgia">Georgia (EN)</Option>
                            <Option value="tahoma">Tahoma (EN)</Option>
                            <Option value="trebuchet">Trebuchet MS (EN)</Option>
                            <Option value="verdana">Verdana (EN)</Option>
                            <Option value="prompt">Prompt (TH-EN)</Option>
                            <Option value="kanit">Kanit (TH-EN)</Option>
                            <Option value="sarabun">Sarabun (TH-EN)</Option>
                            <Option value="pridi">Pridit (TH-EN)</Option>
                            <Option value="noto_sans">
                                Noto Sans Thai (TH-EN)
                            </Option>
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label={
                            <div className="font-semibold mb-2 text-sm">
                                {t('Font size')}
                            </div>
                        }
                        name={['fontStyle', 'fontSize']}
                    >
                        <Radio.Group className="radio-custom">
                            <Space>
                                <Radio
                                    // className={value === true ?`border-[#7B67FB] border-solid border rounded-lg p-2 shadow-md w-80` :`border-[#DBDBDB] border-solid border rounded-lg p-2 w-80`}
                                    value="14px"
                                    style={{ lineHeight: '32px' }}
                                >
                                    {t('Small')}
                                </Radio>
                                <Radio
                                    // className={value === false ?`border-[#7B67FB] border-solid border rounded-lg p-2 shadow-md w-80` :`border-[#DBDBDB] border-solid border rounded-lg p-2 w-80`}
                                    value="16px"
                                    style={{ lineHeight: '32px' }}
                                >
                                    {t('large')}
                                </Radio>
                            </Space>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item
                        label={
                            <div className="font-semibold mb-2 text-sm">
                                {t('Text color Topic')}
                            </div>
                        }
                        name={['fontStyle', 'textTitleColor']}
                        rules={[
                            {
                                validator: checkColorStyle,
                            },
                        ]}
                    >
                        <InputColor />
                    </Form.Item>
                    <Form.Item
                        label={
                            <div className="font-semibold mb-2 text-sm">
                                {t('The color of the text on the card')}
                            </div>
                        }
                        name={['fontStyle', 'textCardColor']}
                        rules={[
                            {
                                validator: checkColorStyle,
                            },
                        ]}
                    >
                        <InputColor />
                    </Form.Item>
                    <Form.Item
                        label={
                            <div className="font-semibold mb-2 text-sm">
                                {t('button text color')}
                            </div>
                        }
                        name={['fontStyle', 'textButtonColor']}
                        rules={[
                            {
                                validator: checkColorStyle,
                            },
                        ]}
                    >
                        <InputColor />
                    </Form.Item>
                    <Form.Item
                        label={
                            <div className="font-semibold mb-2 text-sm">
                                {t('hyperlink')}
                            </div>
                        }
                        name={['fontStyle', 'textLinkColor']}
                        rules={[
                            {
                                validator: checkColorStyle,
                            },
                        ]}
                    >
                        <InputColor />
                    </Form.Item>
                </Collapse>
                <Collapse error={errorLogo} icon={ICON.EIGHT} title={t('Logo')}>
                    <div className="flex justify-between items-center mb-2">
                        <div className="text-xs text-[#65707A]">
                            {t('show logo')}
                        </div>
                        <Form.Item
                            noStyle
                            name={['logo', 'hiddenLogo']}
                            valuePropName="checked"
                        >
                            <Switch />
                        </Form.Item>
                    </div>
                    <div className="mt-2">
                        <Form.Item
                            label={
                                <div className="font-semibold text-xs">
                                    {t('Upload your company logo')}
                                </div>
                            }
                            rules={[
                                {
                                    validator: checkLogo,
                                },
                            ]}
                            name={['logo', 'companyLogoId']}
                            valuePropName="fileList"
                        >
                            <ImgCrop
                                showGrid
                                rotationSlider
                                aspectSlider
                                showReset
                            >
                                <Upload {...uploadProps}>
                                    {fileList.length < 1 && uploadButton}
                                </Upload>
                            </ImgCrop>
                        </Form.Item>
                    </div>
                </Collapse>
            </div>
        </div>
    );
};

const uploadButton = (
    <div className="px-6">
        <svg
            width="41"
            height="32"
            viewBox="0 0 41 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.5024 0C17.2425 0.00879434 14.0938 1.02029 11.6251 2.85175C9.73307 4.25425 8.36221 6.08175 8.00899 7.91562C3.86924 8.70187 0.742188 11.8044 0.742188 15.5507C0.742188 19.9028 4.96099 23.375 10.0813 23.375H19.2674V12.1274L13.9667 16.6898C13.7348 16.8893 13.4203 17.0013 13.0923 17.0013C12.7643 17.0013 12.4498 16.8893 12.2179 16.6898C11.986 16.4902 11.8557 16.2196 11.8557 15.9375C11.8557 15.6554 11.986 15.3848 12.2179 15.1852L19.628 8.81025C19.7427 8.7113 19.879 8.6328 20.029 8.57924C20.1791 8.52567 20.3399 8.4981 20.5024 8.4981C20.6648 8.4981 20.8257 8.52567 20.9757 8.57924C21.1257 8.6328 21.262 8.7113 21.3768 8.81025L28.7868 15.1852C29.0187 15.3848 29.149 15.6554 29.149 15.9375C29.149 16.2196 29.0187 16.4902 28.7868 16.6898C28.5549 16.8893 28.2404 17.0013 27.9124 17.0013C27.5845 17.0013 27.2699 16.8893 27.038 16.6898L21.7374 12.1274V23.375H32.0818C36.5625 23.375 40.2625 20.3363 40.2625 16.5176C40.2625 13.0411 37.1948 10.2085 33.2625 9.73038C32.6623 4.24788 27.1467 0 20.5024 0ZM19.2674 30.8125V23.375H21.7374V30.8125C21.7374 31.0943 21.6073 31.3645 21.3757 31.5638C21.144 31.7631 20.8299 31.875 20.5024 31.875C20.1748 31.875 19.8607 31.7631 19.6291 31.5638C19.3975 31.3645 19.2674 31.0943 19.2674 30.8125Z"
                fill="#C4C4C4"
            />
        </svg>
        <div className="text-[#4F4F4F] opacity-90 text-[10px] pt-4">
            Drop file here, paste or{' '}
            <span className="text-blue">browse file</span>
            <br />
            <br />
            Image only up to 2 MB. (Allowed file types: jpg ,svg or png)
        </div>
    </div>
);

export default CustomizeStyle;
